export enum DocumentControlRuleType {
  ChangeDateAtListLevel = 'changeDateAtListLevel',
  MultiplyNumberOfPackages = 'multiplyNumberOfPackages',
  AdjustDateAtAll = 'adjustDateAtAll',
  AdjustNumberOfItems = 'adjustNumberOfItems',
}
